import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { CSSProperties } from 'react';
import {
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  margin,
  MarginProps,
  padding,
  PaddingProps,
  position,
  PositionProps,
} from 'styled-system';

import { theme } from '@/styles/theme';
import { GapProps } from '@/styles/types';

export const Flex = styled('div', {
  shouldForwardProp: isPropValid,
})<
  FlexboxProps &
    GapProps & {
      overflow?: CSSProperties['overflow'];
    } & MarginProps &
    PaddingProps &
    PositionProps &
    LayoutProps & {
      as?: React.ElementType;
    }
>(flexbox, margin, padding, position, layout, props =>
  css({ display: 'flex', ...theme.gap(props) })
);
